export function iframePointFromClient(iframe, clientX, clientY) {
  const rect = iframe && typeof iframe.getBoundingClientRect === 'function'
    ? iframe.getBoundingClientRect()
    : {left: 0, top: 0};
  return {
    x: clientX - (rect.left || 0),
    y: clientY - (rect.top || 0),
  };
}

export function dispatchPointerIntoIframe(iframe, sourceEvent) {
  const doc = iframe && iframe.contentDocument;
  const win = iframe && iframe.contentWindow;
  if(!doc || !win || !sourceEvent) return false;

  const {x, y} = iframePointFromClient(iframe, sourceEvent.clientX, sourceEvent.clientY);
  const target = (typeof doc.elementFromPoint === 'function' && doc.elementFromPoint(x, y))
    || (typeof doc.querySelector === 'function' && doc.querySelector('.esri-view-surface'))
    || doc.body;
  if(!target || typeof target.dispatchEvent !== 'function') return false;

  const init = {
    bubbles: true,
    cancelable: true,
    composed: true,
    view: win,
    detail: sourceEvent.detail || 1,
    screenX: sourceEvent.screenX,
    screenY: sourceEvent.screenY,
    clientX: x,
    clientY: y,
    ctrlKey: !!sourceEvent.ctrlKey,
    shiftKey: !!sourceEvent.shiftKey,
    altKey: !!sourceEvent.altKey,
    metaKey: !!sourceEvent.metaKey,
    button: sourceEvent.button || 0,
    buttons: sourceEvent.buttons == null ? 1 : sourceEvent.buttons,
  };

  const PointerEventCtor = win.PointerEvent || (typeof PointerEvent === 'function' ? PointerEvent : null);
  if(PointerEventCtor){
    target.dispatchEvent(new PointerEventCtor(sourceEvent.type, {
      ...init,
      pointerId: sourceEvent.pointerId || 1,
      pointerType: sourceEvent.pointerType || 'mouse',
      isPrimary: sourceEvent.isPrimary !== false,
    }));
  }

  const mouseType = sourceEvent.type === 'pointerdown' ? 'mousedown'
    : sourceEvent.type === 'pointerup' ? 'mouseup'
    : sourceEvent.type === 'pointermove' ? 'mousemove'
    : null;
  const MouseEventCtor = win.MouseEvent || (typeof MouseEvent === 'function' ? MouseEvent : null);
  if(mouseType && MouseEventCtor){
    target.dispatchEvent(new MouseEventCtor(mouseType, init));
  }

  return true;
}

/**
 * Keep the parent-page scroll shield mounted (so wheel stays native/smooth)
 * but drop it only for the current pointer gesture and replay that down
 * into the same-origin map iframe so drag starts on the first click.
 */
export function passPointerThroughMapShield(shieldEl, iframe, event, targetWindow = window) {
  if(!shieldEl || !event) return () => {};

  shieldEl.style.pointerEvents = 'none';
  dispatchPointerIntoIframe(iframe, event);

  const restore = () => {
    shieldEl.style.pointerEvents = '';
    if(targetWindow && typeof targetWindow.removeEventListener === 'function'){
      targetWindow.removeEventListener('pointerup', restore, true);
      targetWindow.removeEventListener('pointercancel', restore, true);
    }
  };

  if(targetWindow && typeof targetWindow.addEventListener === 'function'){
    targetWindow.addEventListener('pointerup', restore, true);
    targetWindow.addEventListener('pointercancel', restore, true);
  }

  return restore;
}
